import styles from './FJFilterType.module.less';
import FJButton from '../../../../common/components/FJButton/FJButton';
import { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import FJLocalStore from '../../../../store/FJLocalStore';
import { COMMUNITY_SORT_TYPE } from '../../../../config/dataConfig/FJCommunityData';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew';
import FJCheckIcon from '../../../../assets/svg/choose.svg?react';
import FJUtil from '../../../../util/FJUtil';

const FJFilterType = props => {
    const {
        communityTypes = [],
        curCommunityType = '',
        curCommunityCategory = '',
        onChangeType = () => {},
        onChangeCategory = () => {},
        embedded,
        onChangeSortType = () => {},
        curCommunitySortType = '',
    } = props;
    const [stateSortTypeActive, setStateSortTypeActive] = useState(false);
    const curTag = FJLocalStore.currentTag();
    const typeList = useMemo(() => {
        return communityTypes.map(item => {
            return {
                type: item.type,
                name: item.local[curTag] || item.type,
                list: !item?.list
                    ? []
                    : item?.list?.map(item => {
                          return {
                              type: item.type,
                              name: item.local[curTag] || item.type,
                          };
                      }),
            };
        });
    }, [communityTypes, curTag]);
    const categoryList = useMemo(() => {
        return typeList.find(item => item.type === curCommunityType)?.list || [];
    }, [typeList, curCommunityType]);
    const _onChangeType = type => {
        if (curCommunityType === type) {
            return;
        }
        onChangeType(type);
    };
    const _onChangeCategory = category => {
        if (curCommunityCategory === category) {
            return;
        }
        onChangeCategory(category);
    };
    const curSortTypeItem = COMMUNITY_SORT_TYPE.find(item => item.value === curCommunitySortType);
    const _renderTrigger = config => {
        return (
            <div
                className={classNames(styles.sort_type_item, { [styles.active]: stateSortTypeActive })}
                ref={config.ref}
                onClick={config.onClick}
            >
                {!!curSortTypeItem.icon && <curSortTypeItem.icon className={styles.sort_type_icon} />}
                <FJTextWithEllipsis className={styles.sort_type_text} text={FJLocalStore._(curSortTypeItem.name)} />
            </div>
        );
    };
    const _renderOverlay = config => {
        return (
            <div className={styles.sort_type_overlay} ref={config.ref}>
                {COMMUNITY_SORT_TYPE.map(item => (
                    <div
                        key={item.value}
                        className={styles.sort_type_item}
                        onClick={() => onChangeSortType(item.value)}
                    >
                        <FJTextWithEllipsis className={styles.sort_type_text} text={FJLocalStore._(item.name)} />
                        {item.value === curCommunitySortType && <FJCheckIcon className={styles.check_icon} />}
                    </div>
                ))}
            </div>
        );
    };
    return (
        <div className={classNames(styles.header, { [styles.embedded]: embedded })}>
            <div className={styles.left}>
                <div className={styles.types_list}>
                    {typeList.map(item => (
                        <FJButton
                            key={item.type}
                            text={item.name}
                            className={classNames(styles.type_item, {
                                [styles.normal]: curCommunityType !== item.type,
                            })}
                            textClassName={styles.type_item_text}
                            type={curCommunityType === item.type ? FJButtonType.GRADIENT : 'default'}
                            onClick={() => _onChangeType(item.type)}
                        />
                    ))}
                </div>
                {categoryList && categoryList.length > 0 && (
                    <div className={styles.categories_list}>
                        {categoryList.map(item => (
                            <span
                                key={item.type}
                                className={classNames(styles.category_item, {
                                    [styles.active]: curCommunityCategory === item.type,
                                })}
                                onClick={() => _onChangeCategory(item.type)}
                            >
                                {item.name}
                            </span>
                        ))}
                    </div>
                )}
            </div>
            <div className={styles.right}>
                {!!curSortTypeItem && (
                    <FJDropdownNew
                        isTopLayer={true}
                        renderTrigger={_renderTrigger}
                        useAnchorBody
                        renderOverlay={_renderOverlay}
                        onShow={() => setStateSortTypeActive(true)}
                        onHide={() => setStateSortTypeActive(false)}
                        offsetTop={6}
                        zIndex={FJUtil.isLandingPage() ? 4 : 9999}
                    />
                )}
            </div>
        </div>
    );
};

FJFilterType.propTypes = {
    communityTypes: PropTypes.array,
    curCommunityType: PropTypes.string,
    curCommunityCategory: PropTypes.string,
    onChangeType: PropTypes.func,
    onChangeCategory: PropTypes.func,
    embedded: PropTypes.bool,
    onChangeSortType: PropTypes.func,
    curCommunitySortType: PropTypes.string,
};
export default FJFilterType;
